export const APP_NAME: string = 'Oneway Catering';

export const MODAL_BODY_TYPES: { [key: string]: string } = Object.freeze({
  DEFAULT: 'DEFAULT',
  ITEMS_ADD_NEW: 'ITEMS_ADD_NEW',
});

export const RIGHT_DRAWER_TYPES: { [key: string]: string } = Object.freeze({
  DEFAULT: 'DEFAULT',
  NOTIFICATION: 'NOTIFICATION',
  CART: 'CART',
});

export const CONFIRMATION_MODAL_CLOSE_TYPES: { [key: string]: string } =
  Object.freeze({
    DEFAULT: 'DEFAULT',
  });

export const IS_PROD = process.env.NEXT_PUBLIC_NODE_ENV === 'production';
export const SECRET_KEY = process.env.JWT_SECRET;
export const TOKEN_EXPIRATION = undefined; // process.env.TOKEN_EXPIRATION
// ? +process.env.TOKEN_EXPIRATION
// : 7 * 24 * 60 * 60; // 7 days

export const TAX_RATE = 0.1; // 10% GST

export const QUERY_PARAMS = {
  PREVIOUS_URL: 'previous',
  ORDER_ID: 'orderId',
  TYPE: 'type',
};
